import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import CustomCreate from '@/components/global/list/CustomCreate.jsx';
import PropTypes from 'prop-types';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import DeviceGroupForm from '@/components/deviceGroup/DeviceGroupForm.jsx';
import TagCategoryToolbar from '@/components/global/tags/TagCategoryToolbar';

const DeviceGroupCreate = ({ handleClose }) => {
    const translate = useTranslate();
    return (
        <Box>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.deviceGroup.labels.newDeviceGroup')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    '& .MuiCardContent-root': {
                        marginBottom: '15px !important',
                    },
                    '& .MuiPaper-root .MuiCardContent-root .MuiStack-root': {
                        marginBottom: '0 !important',
                    },
                }}
                className='popup-wrapper border-bottom'
            >
                <Box className='popup-box'>
                    <CustomCreate handleClose={handleClose}>
                        <DeviceGroupForm
                            toolbar={
                                <TagCategoryToolbar onCancel={handleClose} cancelLabel={translate('common.cancel')} saveLabel={translate('common.save')} />
                            }
                        />
                    </CustomCreate>
                </Box>
            </Box>
        </Box>
    );
};

DeviceGroupCreate.propTypes = {
    handleClose: PropTypes.func,
};

export default DeviceGroupCreate;
